const alPairText = JSON.parse(document.getElementById('al-runtime-i18n').textContent);
/* Complementary items use Shopify's native cart. No pricing or discount overrides. */
if (!customElements.get('al-product-pairing')) {
  customElements.define('al-product-pairing', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('change', (event) => {
        if (!event.target.matches('select[name="id"]')) return;
        const form = event.target.closest('form');
        const button = form.querySelector('button');
        button.disabled = false;
        button.innerHTML = alPairText.add + ' <span aria-hidden="true">+</span>';
        form.closest('article').querySelector('[data-al-pair-status]').textContent = '';
        const price = event.target.selectedOptions[0]?.dataset.price;
        if (price) form.closest('article').querySelector('[data-al-pair-price]').textContent = price;
      });
      this.addEventListener('submit', async (event) => {
        const form = event.target.closest('[data-al-pair-form]');
        if (!form || !this.contains(form)) return;
        event.preventDefault();
        const button = form.querySelector('button');
        if (button.disabled) return;
        const status = form.closest('article').querySelector('[data-al-pair-status]');
        status.removeAttribute('data-error');
        status.textContent = '';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = alPairText.adding;
        let added;
        try {
          const response = await fetch(form.action + '.js', {
            method: 'POST', body: new FormData(form), headers: {Accept: 'application/json'}
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error('Cart add rejected');
          added = data;
          button.textContent = alPairText.added;
          status.textContent = alPairText.added_message;
        } catch (_) {
          button.disabled = false;
          button.innerHTML = alPairText.retry + ' <span aria-hidden="true">+</span>';
          status.setAttribute('data-error', '');
          status.textContent = alPairText.unconfirmed;
        } finally {
          button.removeAttribute('aria-busy');
        }
        if (!added) return;
        // Keep the header count and Dawn's native quantity notices in sync.
        try {
          const response = await fetch(this.dataset.cartUrl + '.js', {headers: {Accept: 'application/json'}});
          if (!response.ok) return;
          const cart = await response.json();
          const icon = document.getElementById('cart-icon-bubble');
          if (icon) {
            icon.setAttribute('aria-label', alPairText.cart + ', ' + cart.item_count + ' ' + alPairText.items);
            let bubble = icon.querySelector('.cart-count-bubble');
            if (!bubble && cart.item_count > 0) {
              bubble = document.createElement('span');
              bubble.className = 'cart-count-bubble';
              icon.appendChild(bubble);
            }
            if (bubble) bubble.textContent = cart.item_count;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source: 'al-product-pairing', productVariantId: added.variant_id || added.id, cartData: cart});
          }
        } catch (_) { /* The item is already added; never repeat the POST after a count refresh failure. */ }
      });
    }
  });
}

